<template>
  <div>
    <!-- <router-link :to="'/goal/'+goalId+'/kanban'">link</router-link> -->
    <div
      @click="onToggle"
      v-tooltip="{ content:
          (commitment.committedTime / 3600 || 0).toFixed(1) + ' hours committed<br />'
          + (commitment.recordedTime / 3600 || 0).toFixed(1) + ' hours recorded<br />'
          + ((commitment.committedTime - commitment.recordedTime) / 3600).toFixed(1) + ' hours remaining <br />'
          + 'Number of Tasks: ' + itemCount + '<br />'
          + 'Completed Tasks: ' + itemCountDone + '<br />'
      }">
      <el-progress
        :percentage="percentage_complete"
        :stroke-width="10"
        :color="show_completed ? '' : 'red'"
        :status="percentage_complete === 100 ? 'success' : null" />
    </div>
  </div>
</template>

<script>
// TODO: Move to elements?
// TODO: Berücksichtigt nicht tasks von anderen mitgliedern

export default {
  /* INFO: This component can only be used, if the commitment belongs to
           the current user! */
  props: {
    commitmentMeta: { required: true },
    goalId: { required: true }
  },
  data: () => ({
    show_completed: true
  }),
  computed: {
    commitment() {
      // TODO: Careful, this information is only available to some users!!
      // TODO: Rather sync entire list one level highter .subscribeList() and use .getNode here
      if (this.commitmentMeta.$ready) {
        return this.$models.commitment
          .with({ goalId: this.goalId })
          .subscribeNode( this.commitmentMeta.$id );
      } else {
        return null
      }
    },

    itemCount() {
      return this.tasklist_this_lane.items.length;
    },

    itemCountDone() {
      return this.tasklist_this_lane.items.filter(item => item.done).length;
    },

    durationDoneSum() {
      return this.tasklist_this_lane.items.filter(item => item.durationDone).reduce((v,p) => p.durationDone + v, 0) // filter durationDone can be removed in production, because field will exist
    },

    durationRemainingSum() {
      return this.tasklist_this_lane.items.reduce((v,p) => !isNaN(v) ? p.durationRemaining + v : 0, 0)
    },

    percentage_complete() {
      // if (this.itemCount === 0 || this.durationDoneSum === 0 ||  this.durationRemainingSum === 0) {
      //   return 5.0
      // }

      /*let percentage_complete

      if ( this.show_completed ) {
        percentage_complete = this.durationDoneSum  / ( this.durationDoneSum + this.durationRemainingSum) * 100
      } else {
        // this.commitment.remainingTime
        let durationCommitted = this.commitment.committedTimeDaily * 3600;
        percentage_complete = ( this.durationRemainingSum  /  durationCommitted ) * 100
        // TODO: limit to 100%, otherwise prop check will fail
      }

      if ( isNaN(percentage_complete) ) {
        return 0.0 // When initial % are given, it should be explained in popover
      }*/
      if (this.commitment.recordedTime && this.commitment.committedTime) {
        return Math.round( this.commitment.recordedTime / this.commitment.committedTime * 100)
      } else {
        return 0
      }
    },
    tasklist_this_lane() {
      return this.tasklist
              .asArraySorted()
              .asArrayFilteredBy( 'laneId', this.commitmentMeta.$id );
    },

    tasklist() {
      // TODO: Won't work for other users!
      // TODO: Move to $models.task.custom_getter
      // TODO: this.$models.user.getUID();
      let currentUserId = this.$models.user.defaultUserId;
      // TODO: Also get tasks from team and other users, depending on members
      return this.$models.taskMeta
              .with({ goalId: this.goalId, uid: currentUserId })
              .subscribeList()
      // return []
    },
    tasklist_items() {
      return this.tasklist.map()
    },
  },
  methods: {
    onToggle() {
      this.show_completed = !this.show_completed;
    },
    // onClickCommitmentCard() { },
    onOpenCommitmentModal() {
      this.$root.showUpdateModal('effort', {
        goalId: this.goalId,
        commitmentId: this.commitmentMeta.$id
      });
    },
  },
  components: {
  }
}
</script>
